import React from 'react';

import Navbar from 'components/Navbar';
import SettingSidebar from 'components/Navbar/SettingsSidebar';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import NotificationsHeader from './NotificationsHeader';
import NotificationsTable from './NotificationsTable';

const NotificationsList: React.FC = () => {
  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <>
      <div
        className="min-w-screen bg-white"
        style={{
          height: `calc(100vh - ${warningBarOffset}px)`,
        }}
      >
        <Navbar />
        <div
          className="flex flex-row w-full"
          style={{
            height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
          }}
        >
          <SettingSidebar />

          <div className="pt-4 h-full w-full flex flex-col gap-2 overflow-hidden">
            <NotificationsHeader />
            <main className="h-full w-full flex flex-col overflow-hidden">
              <NotificationsTable />
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationsList;
